import { Step, StepLabel, Stepper } from "@mui/material";

export const MeetingStepper = ({ activeStep }: { activeStep: number }) => {

    const STEPS = ['Schedule', 'Agenda', 'Attendees', 'Projects'];

    return (
        <Stepper
            activeStep={activeStep}
        >
            {STEPS.map(label => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    )

}